import { call, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import ls from 'local-storage'
import log from 'loglevel'

import { localeKey, SET_LOCALE } from './constants'
import { SOCKET_ON_MESSAGE, SOCKET_ACTION_TYPE } from '../socket/constants'

import { setLocale } from './actions'

import { selectedLanguage } from './reducer'

function* saveLocaleCallSaga(_action) {
    const locale = _.get(_action, 'data.locale', selectedLanguage)

    yield call(ls, localeKey, locale)

    return null
}

function* changeLocaleFromSocket(_action) {
    const type = _.get(_action, 'data.type', null)
    if (type !== SOCKET_ACTION_TYPE.CHANGE_LANGUAGE) return null

    const language = _.get(_action, 'data.content.language', selectedLanguage)

    yield put(setLocale(language))

    log.info(`(New stack) Change language to ${language}`)

    return null
}

export default function* translationsSaga() {
    yield takeEvery(SET_LOCALE, saveLocaleCallSaga)
    yield takeEvery(SOCKET_ON_MESSAGE, changeLocaleFromSocket)
}
